export enum PeFormResponseType {
  Create,
  Submit,
  Accept,
  AcceptReject
}
